import React from 'react';
import * as S from './GoStaysPromises.styles';
import {FlexCentered} from '../../../CommonStyleUtils/dwebCommon.styles';

const GoStaysPromises = ({actionHandler, promises}) => {
  return (
    <S.WrapperDivContainer>
      {/* <S.SliderGoStaysCircle /> */}
      <S.GoStayHoverHeader>
        <S.GoStayImageWrap src="https://gos3.ibcdn.com/gostar_srp-1559804785.png" />
        <S.GoStayTitleWrap>goStays Certified</S.GoStayTitleWrap>
      </S.GoStayHoverHeader>
      <S.GoStayHoverContentOuter>
        <S.GoStayHoverContent>
          {promises.map(item => (
            <FlexCentered>
              <S.ShieldIconWrap fill="white" />
              <S.GoStayHoverList>{item}</S.GoStayHoverList>
            </FlexCentered>
          ))}
        </S.GoStayHoverContent>
        <S.ShowPropertiesBtn onClick={actionHandler}>Show goStays properties</S.ShowPropertiesBtn>
      </S.GoStayHoverContentOuter>
    </S.WrapperDivContainer>
  );
};

export default GoStaysPromises;
